import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import get from 'lodash/get';

import * as ActionTypes from '../../actions/ActionTypes';
import * as Controls from '../UIControlsNames';


// add captions manually to menu select for captions embedded in live streams
const addCaptionsToMenuEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_READY)
    .switchMap(() => Observable.fromEvent(player.tech_.el().textTracks, 'addtrack'))
    .filter(({ track }) => track.kind === 'captions')
    .do(({ track }) => player.tech_.remoteTextTracks().addTrack(track)) // attach embedded cea 708 captions to videojs menu controls
    .ignoreElements();


// removes selected check from all menu items and adds it back to clicked item
const handleCaptionChangeEpic = (action$, store, { player }) => Observable
    .fromEvent(player.tech_.el().textTracks, 'change')
    .do((e) => {
        let showing = 1; // Start at 1 (captions off), 0 is hidden settings menu
        for (let i = e.target.length; i >= 0; --i) {
            const track = e.target[i];
            if (track && track.mode === 'showing') {
                showing = i + 2;
                break;
            }
        }

        const captionsControl = player.controlBar.getChild(Controls.CAPTIONS_CONTROL);
        const captionsMenuItems = get(captionsControl.children(), '[1]') ? captionsControl.children()[1].children() : [];

        captionsMenuItems.forEach((menuItem, i) => {
            if (i === showing) {
                menuItem.addClass('vjs-selected');
            } else {
                menuItem.removeClass('vjs-selected');
            }
        });
    })
    .ignoreElements();


// placeholder remove track event
const handelCaptionRemoveEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_READY)
    .switchMap(() => Observable.fromEvent(player.tech_.el().textTracks, 'removetrack'))
    .ignoreElements();


export default combineEpics(
    addCaptionsToMenuEpic,
    handleCaptionChangeEpic,
    handelCaptionRemoveEpic,
);



// CAPTION STUFF
// .do(videoSource => {
    // var tracks = player.textTracks();
    // for (var i = 0; i < tracks.length; i++) {
    //     var track = tracks[i];

    //     player.removeRemoteTextTrack(track);
    //     // this.videoJS.tech_.textTracks().removeTrack_(track);  // removes it permanently, can't be added back by hls.js
    // }
    // if (videoSource.vttURL) {
    //     var track = {
    //         kind: 'captions',
    //         label: 'English',
    //         default: false,
    //         mode: 'hidden',
    //         srclang: 'en',
    //         src: videoSource.vttURL,
    //     };
    //     // player.tech_.el().setAttribute('crossorigin', 'anonymous');
    //     player.tech_.addRemoteTextTrack(track);  // removes it permanently, can't be added back by hls.js
    //     // player.addRemoteTextTrack(track);
    // }

// })



// WEBPACK FOOTER //
// ./src/ui/captions/epics.js